<div class="section-bottom">
  <div class="section1">
    <div class="left">
      <div class="left-box">
        <div style="text-align: center">
          <img class="yephome-logo" id="logoBottom" src="./assets/images/home/logo-bottom.png" style="width: 210px;
    height: 64px;">
        </div>
        <form [formGroup]="sform">
        <div class="box-email" style="margin-top: 100px">
          <label class="email-label" style="color: #777777;" [ngStyle]="{color: submitted && f.email.errors ? 'red' : 'rgba(222, 222, 222, 0.4)'}">Email</label>
          <input type="text" class="input-email" matInput [(ngModel)]="subscribeEmail" matInput formControlName="email" (input)="subscrbeChange()">
        </div>
        <div class="box-control">
          <button (click)="handleToSave()" class="sub-button" [ngClass]="{'subscribe_btn': !suscribeError,'subscribe_btn_fail':suscribeError}" [disabled]="!cansubmit">
            <ng-container>
              {{submitBtnText}}
            </ng-container>
          </button>
        </div>
        </form>

      </div>
    </div>
    <div class="right">
      <mat-list role="list">
        <mat-list-item role="listitem" class="cursor_pointer mat-list" (click)="toYepDeveloper()" id="YepDeveloper">YepDeveloper</mat-list-item>
        <mat-list-item role="listitem" class="cursor_pointer mat-list" (click)="toYepAgent()" id="YepAgent">YepAgent</mat-list-item>
        <mat-list-item role="listitem" class="cursor_pointer mat-list" (click)="toYepIo()">Yephome.com.au</mat-list-item>
        <mat-list-item role="listitem" class="cursor_pointer mat-list" (click)="toContact()">Contact us</mat-list-item>
        <mat-list-item role="listitem" class="cursor_pointer mat-list">
          <div class="icon-group">
            <div class="border-icon" (click)="toLinkedin()">
              <fa-icon [icon]="faLinkedin" class="icon cursor_pointer"></fa-icon>
            </div>
            <div class="border-icon" (click)="toFacebook()">
              <fa-icon [icon]="faFacebook" class="icon cursor_pointer"></fa-icon>
            </div>
            <div class="border-icon" (click)="toIns()">
              <fa-icon [icon]="faInstagram" class="icon cursor_pointer"></fa-icon>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
  <div class="section1">

    <div class="bottom" style="width:40%;padding-bottom: 40px;">

      <div style="color: #777777;" style="white-space: nowrap;">YepTech Services Pty Ltd. © 2024 YepTech All rights reserved </div>
      <div class="cursor_pointer" style="white-space: nowrap;" (click)="toPrivacy()">Privacy Policy</div>
      <div class="cursor_pointer" style="white-space: nowrap;" (click)="toTerms()">Terms & Conditions</div>
    </div>
  </div>
</div>
